import { rootApi } from '../../services/rootApi';
import { sectionApi } from '../../utils/urls';

export const sectionsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    updateSection: builder.mutation({
      query: ({ sectionData }) => ({
        url: sectionApi(),
        method: 'POST',
        body: {
          data: sectionData,
          method: 'update'
        },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: (result, error, { sectionData }) => [
        { type: 'Section', id: sectionData.id },
        { type: 'Course', id: sectionData.courseId }
      ],
    }),
  }),
});

export const {
  useUpdateSectionMutation,
} = sectionsApiSlice; 